export default __webpack_public_path__ + "static/imgOfFirstScreen-2b9c2871b6786ad766cee597c8bb0dcb.png";